import styled from 'styled-components';

export const Bottom = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10px;

  transform: translateY(50%);

  cursor: s-resize;
`;
